import axios from "axios";
import {
  SETTING_GET_SUCCESS,
  SETTING_GET_FAIL,
  SETTING_UPDATE_FAIL,
  SETTING_UPDATE_SUCCESS,
  ERROR_CLEAR,
  SUCCESS_MESSAGE_CLEAR,
  TEST_MAIL_SUCCESS,
  TEST_MAIL_FAIL,
  // Add new 2FA action types
  TEST_OTP_SUCCESS,
  TEST_OTP_FAIL,
  GET_2FA_SETTINGS_SUCCESS,
  GET_2FA_SETTINGS_FAIL,
  UPDATE_2FA_SETTINGS_SUCCESS,
  UPDATE_2FA_SETTINGS_FAIL,
  TOGGLE_2FA_USER_SUCCESS,
  TOGGLE_2FA_USER_FAIL
} from "../types/settingTypes";

import { SERVER_URL } from '../../config/dev';
import { update } from "lodash";

const initialState = {
  settings: null,
  successMessage: {
    get: "",
    update: "",
    testOtp: "", // Add success message for OTP test
    get2FA: "",  // Add success message for getting 2FA settings
    update2FA: "", // Add success message for updating 2FA settings
    toggle2FA: ""  // Add success message for toggling user 2FA
  },
  errorMessage: null
};

export const SettingReducer = (state = initialState, action) => {
  const { payload, type } = action;

  if (type === SETTING_GET_SUCCESS) {
    // If settings include 2FA settings, ensure they're properly structured
    let settingsData = payload.settings && payload.settings.length > 0 ? payload.settings[0] : null;

    // Initialize twoFactorSettings if they don't exist
    if (settingsData && !settingsData.twoFactorSettings) {
      settingsData = {
        ...settingsData,
        twoFactorSettings: {
          enabled: false,
          requiredForAdmins: false,
          requiredForAllUsers: false,
          otpLength: 6,
          otpExpiryMinutes: 10
        }
      };
    }

    return {
      ...state,
      settings: settingsData,
      successMessage: {
        ...state.successMessage,
        get: payload.successMessage,
      },
    }
  }

  if (type === SETTING_GET_FAIL) {
    return {
      ...state,
      errorMessage: payload.errorMessage,
    };
  }

  if (type === SETTING_UPDATE_SUCCESS) {
    return {
      ...state,
      settings: payload.settings && payload.settings.length > 0 ? payload.settings[0] : null,
      successMessage: {
        ...state.successMessage,
        update: payload.successMessage,
      },
    }
  }

  if (type === SETTING_UPDATE_FAIL) {
    return {
      ...state,
      errorMessage: payload.errorMessage,
    };
  }

  if (type === SUCCESS_MESSAGE_CLEAR) {
    return {
      ...state,
      successMessage: {
        get: "",
        update: "",
        testOtp: "",
        get2FA: "",
        update2FA: "",
        toggle2FA: ""
      },
    }
  }

  if (type === ERROR_CLEAR) {
    return {
      ...state,
      errorMessage: null
    }
  }

  if (type === TEST_MAIL_SUCCESS) {
    return {
      ...state,
      successMessage: {
        ...state.successMessage,
        update: payload.successMessage
      }
    }
  }

  if (type === TEST_MAIL_FAIL) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    }
  }

  // Handle new 2FA action types
  if (type === TEST_OTP_SUCCESS) {
    return {
      ...state,
      successMessage: {
        ...state.successMessage,
        testOtp: payload.successMessage
      }
    }
  }

  if (type === TEST_OTP_FAIL) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    }
  }

  if (type === GET_2FA_SETTINGS_SUCCESS) {
    // Update settings with 2FA settings
    return {
      ...state,
      settings: state.settings ? {
        ...state.settings,
        twoFactorSettings: payload.twoFactorSettings
      } : null,
      successMessage: {
        ...state.successMessage,
        get2FA: payload.successMessage
      }
    }
  }

  if (type === GET_2FA_SETTINGS_FAIL) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    }
  }

  if (type === UPDATE_2FA_SETTINGS_SUCCESS) {
    // Update settings with new 2FA settings
    return {
      ...state,
      settings: state.settings ? {
        ...state.settings,
        twoFactorSettings: payload.twoFactorSettings
      } : null,
      successMessage: {
        ...state.successMessage,
        update2FA: payload.successMessage
      }
    }
  }

  if (type === UPDATE_2FA_SETTINGS_FAIL) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    }
  }

  if (type === TOGGLE_2FA_USER_SUCCESS) {
    return {
      ...state,
      successMessage: {
        ...state.successMessage,
        toggle2FA: payload.successMessage
      }
    }
  }

  if (type === TOGGLE_2FA_USER_FAIL) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    }
  }

  return state;
}